<div id="red-ribbon-club" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Red Ribbon Club</h2>
    <p class="inner-lead mt-3">
      The Red Ribbon Club is dedicated to raising awareness about HIV/AIDS, promoting safe practices, and reducing the stigma associated with the disease. Their major contributions include organizing regular seminars, workshops, and interactive sessions to educate students about HIV/AIDS, conducting community outreach activities, and providing health and wellness programs such as free HIV testing camps and counselling sessions.
    </p>

    <hr class="divider">

    <p>Both YRC and the Red Ribbon Club work in close collaboration with local health authorities, non-governmental organizations, and other educational institutions, leading to significant achievements such as increased health awareness, improved community health standards, and enhanced student participation in social service.</p>

    <p>The college remains committed to providing an environment that nurtures compassion, leadership, and a proactive approach to societal issues as these clubs continue to expand their outreach and impact.</p>

    <hr class="divider">

    <h4 class="section-subtitle">Committee</h4>
    <ul class="list-styled mt-2">
      <li><strong>Convener:</strong> Dr. Monika</li>
      <li><strong>Members:</strong> Dr. Rekha, Ms. Payal</li>
    </ul>

  </div>
</div>
